"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSSH = void 0;
const protocols_1 = require("./protocols");
exports.isSSH = (value) => {
    const results = protocols_1.protocols(value);
    if (results.includes("ssh") || results.includes("rsync") || results.includes("git")) {
        return true;
    }
    value = value.substring(value.indexOf("://") + 3);
    return value.indexOf("@") < value.indexOf(":");
};
//# sourceMappingURL=is-ssh.js.map